const formatPercentage = (value) => {
  if (value === null || value === undefined || value === '') return '-'

  let formatted = String(value).replace('.', ',')

  if (formatted.startsWith(',')) {
    formatted = '0' + formatted
  }

  if (!formatted.endsWith('%')) {
    formatted += '%'
  }

  return formatted
}

export const buildIndicadoresSection = (indicadores) => {
  if (!indicadores) return ''
  const { denuncias, estado, frecuencia } = indicadores
  const v = (x) => (x !== undefined && x !== null ? x : '-')

  return `
    <div class="cards">
      <div class="card">
        <table>
          <tr>
            <th>Denuncias</th>
            <th>Cantidad</th>
          </tr>
          <tr><td>Total de denuncias</td><td style="text-align:center;">${v(denuncias?.totalDenuncias)}</td></tr>
          <tr><td>Autodenuncias</td><td style="text-align:center;">${v(denuncias?.autodenuncias)}</td></tr>
          <tr><td>Rechazos</td><td style="text-align:center;">${v(denuncias?.rechazos)}</td></tr>
        </table>
      </div>
      <div class="card">
        <table>
          <tr>
            <th>Estados de los siniestros</th>
            <th>Cantidad</th>
          </tr>
          <tr><td>Altas</td><td style="text-align:center;">${v(estado?.altas)}</td></tr>
          <tr><td>Recaídas</td><td style="text-align:center;">${v(estado?.recaidas)}</td></tr>
          <tr><td>Días de baja promedio</td><td style="text-align:center;">${v(estado?.diasBajaPromedio)}</td></tr>
        </table>
      </div>
      <div class="card">
        <table>
          <tr>
            <th>Indicadores frecuenciales </th>
            <th>Cantidad</th>
          </tr>
          <tr><td>Frecuencia siniestral</td><td style="text-align:center;">${frecuencia ? formatPercentage(frecuencia.frecuenciaSiniestral) : '-'}</td></tr>
          <tr><td>Frecuencia judicial</td><td style="text-align:center;">${frecuencia ? formatPercentage(frecuencia.frecuenciaJudicial) : '-'}</td></tr>
          <tr><td>Frecuencia siniestral por CIIU</td><td style="text-align:center;">${frecuencia ? formatPercentage(frecuencia.frecuenciaSiniestralCiiu) : '-'}</td></tr>
        </table>
      </div>
    </div>`
}
